import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Divider, Modal, Row } from 'antd';
import { deleteNotActiveModel } from '../../data/store/instruments/instrumentsActions';

const ModalDeleteModel = ({modalDeleteModel, handleDeleteClose}) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const { modelList, isLoading, isError } = useSelector((state) => state.instrumentsReducer);
  const [errorMessage, setErrorMessage ] = useState(false);

  const getModelById = () => {
    return modelList?.find(i => i.id === modalDeleteModel)?.name;
  };

  const handleErrorMessage = () => {
    setErrorMessage('Error! Cannot delete model');
    setTimeout(() => {
      setErrorMessage(false);
    }, 2500);
  };

  const handleDelete = () => {
    dispatch(deleteNotActiveModel({id: modalDeleteModel, callback: handleDeleteClose, errMessage: handleErrorMessage}));
  };

  return (
    <Modal
        width={700}
        className="modal-content-paper"
        open={modalDeleteModel}
        onCancel={!isLoading && handleDeleteClose}
        footer={null}
        zIndex={1600}>
        <Row justify="start">
          <Col className="modal-title">{t('MODAL_DELETE_TITLE')}</Col>
        </Row>
        <Divider className='modal-divider'/>
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-description">{t('MODAL_DELETE_MODAL')}</p>
            <p className="modal-name">{getModelById()}</p>
          </Col>
        </Row>
        {errorMessage && <Row className='error-del-modal'>{errorMessage}</Row>}

        <Row justify="end" style={{marginTop: '50px'}}>
          <Col>
            <Button
              className='modal-action-btn cancel-btn'
              onClick={handleDeleteClose}
              disabled={isLoading || isError}
            >
              {t('CANCEL')}
            </Button>
            <Button 
              style={{marginLeft: '8px'}} 
              className="modal-action-btn delete-btn" 
              onClick={handleDelete}
              disabled={isLoading}
              >
              {t('DELETE')}
            </Button>
          </Col>
        </Row>
      </Modal>
  );
};

export default ModalDeleteModel;

ModalDeleteModel.propTypes = {
  modalDeleteModel: PropTypes.number,
  handleDeleteClose: PropTypes.func,
};
